import { useIsSuspendedFacade } from './useIsSuspendedFacade';
import { useSuspensionInfo } from '../queries/useSuspensionInfo';

export const useSuspensionInfoFacade = () => {
  const { data: isSuspendedData, isLoading: isLoadingIsSuspended } = useIsSuspendedFacade();
  const isSuspended = !isLoadingIsSuspended && isSuspendedData;
  const suspensionInfoQuery = useSuspensionInfo(isSuspended);

  return suspensionInfoQuery;
};

export type UseSuspensionInfoFacade = ReturnType<typeof useSuspensionInfoFacade>;
